import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'roblex-letter-avatar',
    templateUrl: './letter-avatar.component.html',
    styleUrls: ['./letter-avatar.component.scss'],
})
export class LetterAvatarComponent implements OnInit {
    /**
     * Input  of letter avatar component
     */
    @Input() name: string;
    /**
     * Input width of letter avatar component
     */
    @Input() width: string = '71px';
    /**
     * Gets style
     */
    get style() {
        return {
            width: this.width,
            height: this.width,
        };
    }
    /**
     * Creates an instance of letter avatar component.
     */
    constructor() {}
    /**
     * on init
     */
    ngOnInit(): void {
        //
    }
    /**
     * Gets two letters
     * @returns string
     */
    getTwoLetters(): string {
        const words = this.name?.split(' ');
        let letters = '';

        if (words?.length > 1) {
            words.forEach((value: string, index: number) => {
                if (index < 2) {
                    letters += value.charAt(0).toUpperCase();
                }
            });
        } else if (words?.length === 1) {
            letters += this.name.charAt(0);
            letters += this.name.charAt(this.name.length - 1);
        } else {
            letters += 'RB';
        }

        return letters;
    }
}
